import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";

import noImage from "../assets/images/settings/no-image.png";
import { serverInfo } from "../App";
import { useContext } from "react";

const TopInfo = ({ profile, settings }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const history = useHistory();

  const [user, setUser] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const handleProfile = () => {
    history.push(profile);
  };

  const handleSettings = () => {
    history.push(settings);
  };

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);

          setProfileImage(
            res.data.users.image !== null
              ? imageCdnUrl + res.data.users.image
              : noImage
          );
        }
      });
  }, []);

  const logoutSubmit = (e) => {
    e.preventDefault();

    axios.post(`/api/logout`).then((res) => {
      if (res.data.status === 200) {
        localStorage.removeItem("auth_token");

        // swal("Success", res.data.message, "success");
        history.push("/");
        //browserHistory.push("/path-to-link");
        //window.location.href = "/";
      } else {
        swal("Warning", res.data.message, "Warning");
        //history.push('/');
      }
    });
  };

  return (
    <div>
      <ul className="navbar-nav  navParent">
        <Dropdown>
          <Dropdown.Toggle
            id="dropdown-basic"
            className="d-flex mobile_tap justify-content-center bg-dark align-items-center border-0  "
          >
            <span className="mobile-auth">
              {" "}
              {user?.first_name}
              {user?.last_name}&nbsp;
            </span>
            <img
              src={profileImage ? profileImage : noImage}
              alt=""
              className="custom-nav-img-drop"
            />
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu-admin">
            <Dropdown.Item className="drop-text-nav" onClick={handleProfile}>
              <i className="fa-solid fa-id-card-clip"></i> &nbsp; Profile
            </Dropdown.Item>
            <Dropdown.Item
              className="drop-text-nav c-sxd"
              onClick={handleSettings}
            >
              <i className="fa-solid fa-gear"></i> &nbsp; Setting
            </Dropdown.Item>
            <Dropdown.Item className="drop-text-nav" onClick={logoutSubmit}>
              <i className="fa-solid fa-arrow-right-from-bracket"></i> &nbsp;
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </ul>
    </div>
  );
};

export default TopInfo;
